import React, { useContext, useState } from "react";
import { useQuery } from "@apollo/client";
import CircularProgress from '@mui/material/CircularProgress';
import { CSVLink } from "react-csv";
import { FaFileCsv } from "react-icons/fa6";
import { Button, Typography, Stack } from "@mui/material";
import moment from "moment";
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";
import { GET_STUDENT_PAGINATION } from "../../Schema/Student";

// import { GET_STUDENT_PAGINATION } from "../../Schema/Student";

export default function ExportStudentCSV({ academicYearVal }) {
  // ===================== Change Language ==========================
  const { language, setAlert } = useContext(AuthContext);
  const { t } = translateLauguage(language);
  const [tableData, setTableData] = useState([])
  // console.log("tableDataCVS", tableData);
  // console.log(academicYearVal, "academicYearVal");
  const { refetch} = useQuery(GET_STUDENT_PAGINATION, {
    variables: {
      academicYearId: academicYearVal?.id ? academicYearVal?.id : "",
      // schoolId: schoolVal?.id ? schoolVal?.id : "",
      // levelId: levelVal?.id ? levelVal?.id : "",
      // teacherId: teacherVal?.id ? teacherVal?.id : "",
      // groupId: groupVal?.id ? groupVal?.id : "",
      page: 1,
      limit: 10,
      keyword: "",
      pagination: false,
      attendedStatus: "All",
    },

    onCompleted: ({getStudentPagination})=>{
      console.log(getStudentPagination?.data
        , "getStudentPagination");
      if(getStudentPagination?.data?.length > 0){
        setTableData(getStudentPagination?.data)
      }
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });
  const createCsvFileName = () => `student_data.csv`;

  const headers = [
    { label: "ID", key: "stuId" },
    { label: "Latin Name", key: "latin_name" },
    { label: "Khmer Name", key: "kh_name" },
    { label: "Gender", key: "gender" },
    { label: "Level", key: "level" },
    { label: "Group", key: "group" },
    { label: "Teacher", key: "teacher" },
    { label: "School", key: "school" },
    { label: "Academic year", key: "academic_year" },
    { label: "Status", key: "status" },
    { label: "Drop out date", key: "drop_out_date" },
  ];
  let data = [];

  tableData?.forEach((element) => {
    data.push({
      stuId: element?.student_id,
      latin_name: element?.full_name_latin,
      kh_name: element?.full_name_kh,
      gender: element?.gender,
      level: element?.class_attended?.class_id?.level_id?.level_name,
      group: element?.class_attended?.class_id?.group_id?.group_name,
      teacher: element?.class_attended?.class_id?.teacher_id?.latin_name || `${element?.class_attended?.class_id?.teacher_id?.first_name} ${element?.class_attended?.class_id?.teacher_id?.last_name}`,
      school: element?.class_attended?.class_id?.school_id?.school_name_en, 
      academic_year: element?.class_attended?.class_id?.academic_year_id?.academic_year,
      status: element?.attended_status,
      drop_out_date: element?.drop_out_date ? moment(element?.drop_out_date).format("YYYY-MM-DD") : ""
    });
  });

  
  return (
    <CSVLink
      data={data}
      headers={headers}
      filename={createCsvFileName()}
      target="_blank"
     
    >
      <Stack
        direction="row"
        spacing={1}
        alignItems="center"
        justifyContent="center"
      >
        <FaFileCsv className="icon-csv" />
        <Typography
          className={language === "en" ? "action-txt" : "action-txt-kh"}
        >
          {t("export")}
        </Typography>
        {tableData.length > 0 ? (
          <Typography sx={{fontSize:"14px"}}>({tableData.length} records)</Typography>
        ):(
           <CircularProgress enableTrackSlot size="20px" /> 
        )}
         
      </Stack>
    </CSVLink>
  );
}
